import React, {SVGProps} from 'react';

import {ReactComponent} from '../../assets/svg/chevron_down.svg';

export default (props: SVGProps<any>): JSX.Element => <ReactComponent {...props} />;
